import { useCallback } from 'react';
import { useDynamicReducerDispatch } from '../store';
import * as actions from '../store/actions';

export const useOnProductChange = () => {
    const dispatch = useDynamicReducerDispatch();

    return useCallback(({ currentTarget: { value } }) => {
        dispatch(actions.setProduct(value));
    }, [dispatch]);
};
